import React from 'react'
import { Card } from '@clickcease/cc-client-components-lib'
import { GoogleAnalyticsConnectorWrapper } from './GoogleAnalyticsConnector.styled'
import { Instructions } from './Instructions/Instructions'
import { useTranslation } from 'react-i18next'
import { Connector } from './Connector/Connector'

export const GoogleAnalyticsConnector = () => {
  const { t } = useTranslation('googleAnalytics')
  return (
    <GoogleAnalyticsConnectorWrapper>
      <Card title={t('instructions-title')}>
        <Instructions />
      </Card>
      <Card title={t('ga-connector-title')} css={{ minHeight: '450px' }}>
        <Connector />
      </Card>
    </GoogleAnalyticsConnectorWrapper>
  )
}
